import SessionFrequencyView from './components/frequency-view';

export default SessionFrequencyView;
